import { createContext, useContext } from 'react';

import { DiagramComponentInstance, DiagramConnection } from 'models';

export const EditConnectionContext = createContext<{
    connection: DiagramConnection;
    fromComponentInstance: DiagramComponentInstance | null;
    toComponentInstance: DiagramComponentInstance | null;
    voltageType: 'AC' | 'DC' | null;
    combined: boolean;
    viewOnly: boolean;
} | null>(null);

export const useEditConnectionContext = () => {
    const context = useContext(EditConnectionContext)!;

    const connectionColor = {
        '': 'var(--mantine-color-connection-0)',
        'AC': 'var(--mantine-color-AC-0)',
        'DC': 'var(--mantine-color-DC-0)',
    }[context.voltageType || ''];

    return {
        ...context,
        connectionColor,
        linked: !!context.connection.cableId,
    };
};
